import { render, staticRenderFns } from "./reportes-facturacion-anual.vue?vue&type=template&id=fbb9293a&scoped=true&"
import script from "./reportes-facturacion-anual.vue?vue&type=script&lang=js&"
export * from "./reportes-facturacion-anual.vue?vue&type=script&lang=js&"
import style0 from "./reportes-facturacion-anual.vue?vue&type=style&index=0&id=fbb9293a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb9293a",
  null
  
)

export default component.exports